import http from './../../../base/api/public'

let service = require('@/../config/serviceList')
let sysConfig = require('@/../config/sysConfig')
let apiPre = sysConfig.apiPre

export default {

   getAppUserPage(params) {
      return http.requestPost(apiPre + service.member + '/member/re/customerAndApp/getAppUserPage', params)
    },
  getAppUserOfOperatorPage(params) {
    return http.requestPost(apiPre + service.member + '/member/re/customerAndApp/getAppUserOfOperatorPage', params)
  },
   getAppUserInfo(params) {
    return http.requestGet(apiPre + service.member + '/member/re/operator/listByUserId?userId='+ params)
   },

   deleteAppUserInfo(params) {
      return http.requestPost(apiPre + service.member + '/member/re/customerAndApp/deleteAppUserInfo', params)
    },
    updateAppUserInfo(params) {
      return http.requestPost(apiPre + service.member + '/member/re/customerAndApp/updateAppUserInfo', params)
    },
    getAppRoleList() {
        return http.requestGet(apiPre + service.member + '/member/re/appRole/getAppRoleList')
      },
    getAppRolePage(params) {
        return http.requestPost(apiPre + service.member + '/member/re/appRole/getAppRolePage', params)
      },
    addAppRoleInfo(params) {
        return http.requestPost(apiPre + service.member + '/member/re/appRole/addAppRoleInfo', params)
      },
    updateAppRoleInfo(params) {
        return http.requestPost(apiPre + service.member + '/member/re/appRole/updateAppRoleInfo', params)
      },
    getAppMenuList(params) {
        return http.requestPost(apiPre + service.member + '/member/re/appMenu/getAppMenuList', params)
      },
    deleteAppMenuInfo(params) {
      return http.requestPost(apiPre + service.member + '/member/re/appMenu/deleteAppMenuInfo', params)
    },
    addAppMenuInfo(params) {
      return http.requestPost(apiPre + service.member + '/member/re/appMenu/addAppMenuInfo', params)
    },
    updateAppMenuInfo(params) {
      return http.requestPost(apiPre + service.member + '/member/re/appMenu/updateAppMenuInfo', params)
    }



}



// WEBPACK FOOTER //
// ./src/module/systemManagement/api/appUser.js